import BaseModel from '../base/BaseModel.model';
export default class PorposalMemberEffort extends BaseModel {
   public activityName:string;
   public hour?:number;
   public effortPorcentage:number;
   public timeToDedicateFinal:number;
   public researchCenterId?:number;
   public institutionName:string;
   public timeToStrip:number;
   public effortPorcentageFinal:number;
   public stripActivity:boolean;
    
    init(){
        this.activityName = '';
        this.institutionName = '';
        this.hour = 0;
        this.effortPorcentage = 0;
        this.researchCenterId =  null;  
        this.timeToStrip = 0;
        this.timeToDedicateFinal = null;
        this.effortPorcentageFinal = null;
        this.stripActivity = false;
    }
}